<template>
    <div class="od-carousel__wrapper">
        <div class="od-carousel__container">
            <div class="swiper-container od-carousel" ref="swiper">
                <div class="swiper-wrapper od-carousel__swiper-wrapper" v-if="itemList.length">
                    <div class="swiper-slide" v-for="item in itemList">
                        <category-item
                                :item-data="item.data"
                                :decimal-count="0"
                                :disable-carousel-on-mobile="itemList.length > itemsPerPage">

                            <a :href="item.data | itemURL(false)" :title="item.data | itemName" class="small">
                                <i class="fa fa-image"></i>
                                <span>{{ item.data | itemName }}</span>
                            </a>
                        </category-item>
                    </div>
                </div>
                <div class="swiper-pagination od-carousel__pagination"></div>
            </div>
        </div>
    </div>
</template>

<script>

    import { Swiper } from 'swiper';
    import ApiService from "../../../../../../node_modules/Ceres/resources/js/src/app/services/ApiService";

    export default {
        props: {
            template:
                {
                    type: String,
                    default: "#vue-od-carousel"
                },
            itemsPerPage:
                {
                    type: Number,
                    default: 4
                },
            listtype:
                {
                    type: String,
                    default: ""
                },
            itemsort:
                {
                    type: String,
                    default: ""
                },
            maxitems:
                {
                    type: Number,
                    default: 10
                },
            categoryid:
                {
                    type: Number,
                    default: 0
                },
            itemlistid:{
                type: Number,
                default: 0
            }

        },

        data()
        {
            return {
                itemList: []
            };
        },

        computed:
            {

            },

        created()
        {
            //this.loadItems();
        },

        mounted()
        {

            this.loadItems();

        },

        methods:
            {
                loadItems(){
                    let id = this.itemlistid != 0 ? this.itemlistid : this.categoryid;
                    let query = "?listtype="+this.listtype+"&list_type="+this.listtype+"&type="+this.listtype+"&id="+id+"&sorting="+this.itemsort+"&maxitems="+this.maxitems;

                    ApiService.get(window.location.origin+"/rest/stylebreaker/itemlist"+query)
                        .done(data => {

                            const newItems = data.itemList.documents;
                            this.itemList = [...this.itemList, ...newItems];
                            this.initSwiper();

                        }).fail((err)=> console.log(err));
                },

                initSwiper()
                {
                    const swiperEl = this.$refs.swiper;
                    this.$nextTick(() =>
                    {
                        const swiperItemList = new Swiper($(swiperEl), {
                            pagination: {
                                el: ".od-carousel__pagination",
                                type: "bullets"
                            },
                            slidesPerView: 4,
                            spaceBetween: 10,
                            breakpoints: {
                                767: {
                                    slidesPerView: 3,
                                    spaceBetween: 0
                                },
                                585: {
                                    slidesPerView: 1,
                                    spaceBetween: 0
                                }
                            },
                        })

                    });
                }
            }
    }
</script>
